import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

export default function BannerSlider() {
  const [sliders, setSliders] = useState([]);

  useEffect(() => {
    const fetchSliders = async () => {
      const snapshot = await getDocs(collection(db, "slider"));
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      data.sort((a, b) => a.urutan - b.urutan);
      setSliders(data);
    };
    fetchSliders();
  }, []);

  if (sliders.length === 0) return null;

  return (
    <div className="container mt-4">
      <Carousel fade interval={4000}>
        {sliders.map((slide) => (
          <Carousel.Item key={slide.id}>
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "500px",
                overflow: "hidden",
                borderRadius: "16px",
                backgroundColor: "#000",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* Background blur agar portrait tetap indah */}
              <img
                src={slide.url}
                alt={slide.judul || "Slider"}
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  filter: "blur(20px) brightness(0.6)",
                  transform: "scale(1.1)",
                  zIndex: 1,
                }}
              />

              {/* Gambar utama */}
              <img
                src={slide.url}
                alt={slide.judul || "Slider utama"}
                style={{
                  position: "relative",
                  zIndex: 2,
                  maxWidth: "100%",
                  maxHeight: "100%",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                  borderRadius: "10px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                }}
              />
            </div>

            {(slide.judul || slide.deskripsi) && (
              <Carousel.Caption
                style={{
                  zIndex: 3,
                  backgroundColor: "rgba(0,0,0,0.5)",
                  borderRadius: "8px",
                  padding: "10px 16px",
                }}
              >
                {slide.judul && (
                  <h5
                    style={{
                      fontWeight: "600",
                      fontSize: "1.4rem",
                      textShadow: "0 2px 5px rgba(0,0,0,0.7)",
                    }}
                  >
                    {slide.judul}
                  </h5>
                )}
                {slide.deskripsi && (
                  <p
                    style={{
                      fontSize: "1rem",
                      textShadow: "0 1px 4px rgba(0,0,0,0.6)",
                      marginBottom: 0,
                    }}
                  >
                    {slide.deskripsi}
                  </p>
                )}
              </Carousel.Caption>
            )}
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}
